import { render, staticRenderFns } from "./portfolio-case-study.vue?vue&type=template&id=033ff0f2&scoped=true&lang=pug"
import script from "./portfolio-case-study.vue?vue&type=script&lang=ts"
export * from "./portfolio-case-study.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033ff0f2",
  null
  
)

export default component.exports